<!--头部-->
<template>
    <div class="container">
        <div class="logo">
            <div id="logo">
                <img :src="require('@/assets/imgs/logo.png')" alt />
            </div>
            <div id="login" v-if="UserInfo === null || UserInfo.userAccount === undefined">
                <i class="el-icon-user"></i>&nbsp;
                <span @click="register()">注册 | </span>
                <span @click="login()">登录</span>
            </div>
            <div id="login" v-else>
                <el-image :src="(UserInfo != null && UserInfo.userPhoto != null && UserInfo.userPhoto != '') ? UserInfo.userPhoto : require('@/assets/imgs/person.png')"
                          class="mini-headPhoto"
                          fit="cover">
                </el-image>
                &nbsp;
                <span  @click="toUserCenter()" v-if="UserInfo.authStatus==1">欢迎,{{ UserInfo.name }}<strong style="color:blue;font-size:14px;">(已实名)</strong> | </span>
                <span  @click="toUserCenter()" v-else>欢迎,{{ UserInfo.name }} | </span>
                <span @click="logout()">登出</span>
            </div>
            <Login v-if="dialogVisibleLogin" ref="login" @resetUserInfo="resetUserInfo"></Login>
            <Register v-if="dialogVisibleRegister" ref="register"></Register>
        </div>
        <div class="nav">
            <div id="nav">
                <ul>
                    <li @click="handleClick(1)" :class="checkedIndex == 1 ? 'active' : ''">首页</li>
                    <li @click="handleClick(2)" :class="checkedIndex == 2 ? 'active' : ''">小区展示</li>
                    <li :class="checkedIndex == 3 ? 'active' : ''">
                        公示信息
                        <ul id="nav-publicly" class="shadow">
                            <li v-for="(menu,index) in publiclyList" :key="index" @click="handleClick(3, menu.type, menu.id, menu.title)">
                                {{menu.title}}
                            </li>
                        </ul>
                    </li>                    
                    <li :class="checkedIndex == 4 ? 'active' : ''">
                        新闻资讯
                        <ul id="nav-news" class="shadow">
                            <li v-for="(menu,index) in newsList" :key="index" @click="handleClick(4, menu.type, menu.id, menu.title)">
                                {{menu.title}}
                            </li>
                        </ul>
                    </li>
                    
                    <li :class="checkedIndex == 5 ? 'active' : ''" >
                        办事指南
                        <ul id="nav-service" class="shadow">
                            <li v-for="(menu,index) in serviceMenuList" :key="index" @click="handleClick(5, menu.type, menu.id, menu.title)">
                                {{menu.title}}
                            </li>
                        </ul>
                    </li>
                    <li :class="checkedIndex == 6 ? 'active' : ''" >
                        文档下载
                        <ul id="nav-download" class="shadow">
                            <li v-for="(menu,index) in downloadMenuList" :key="index" @click="handleClick(6, menu.type, menu.id, menu.title)">
                                {{menu.title}}
                            </li>
                        </ul>
                    </li>
                    <li :class="checkedIndex == 7 ? 'active' : ''">
                        关于我们
                        <ul id='nav-about' class="shadow">
                            <li v-for="(menu,index) in contactUsMenuList" :key="index" @click="handleClick(7, menu.type, menu.id, menu.title)">
                                {{menu.title}}
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Register from "../login/Register";
    import Login from "../login/Login";
    import PortalApi from "@/api/portal/index"
    import { getUserInfo, removeLocalToken, removeUserInfo } from "@/store/index";
    export default {
        inject: ["reload"], // 引用父组件方法
        provide() {
            return {
                switchLoginOrRegister: this.switchLoginOrRegister
            }
        },
        data() {
            return {
                dialogVisibleRegister: false,
                dialogVisibleLogin: false,
                checkedIndex: 1,
                UserInfo: {},
                newsList:[],
                policyList:[],
                publiclyList:[],
                contactUsMenuList:[],
                serviceMenuList:[],
                downloadMenuList:[]
            };
        },
        components: { Register, Login },
        methods: {
            // 切换登录或注册的显示
            switchLoginOrRegister(type) {
                if (type == 0) {
                    this.$nextTick(() => {
                        this.$refs.register.dialogVisible = false;
                    });
                    this.dialogVisibleRegister = false;

                    this.dialogVisibleLogin = true;
                    this.$nextTick(() => {
                        this.$refs.login.dialogVisible = true;
                    });
                }
                else {
                    this.$nextTick(() => {
                        this.$refs.login.dialogVisible = false;
                    });
                    this.dialogVisibleLogin = false;

                    this.dialogVisibleRegister = true;
                    this.$nextTick(() => {
                        this.$refs.register.dialogVisible = true;
                    });
                }
            },
            register() {
                this.dialogVisibleRegister = true;
                this.$nextTick(() => {
                    this.$refs.register.dialogVisible = true;
                });
            },
            login() {
                this.dialogVisibleLogin = true;
                this.$nextTick(() => {
                    this.$refs.login.dialogVisible = true;
                });
            },
            toUserCenter() {
                this.checkedIndex=-1
                this.$router.push({ path: "/User" });
            },
            logout() {
                this.UserInfo = null;
                removeLocalToken();
                removeUserInfo();
                this.$router.push({ path: "/" });
                this.reload();
            },
            resetUserInfo() {
                removeUserInfo();
                getUserInfo().then((data) => {
                    this.UserInfo = data;
                });
            },
            handleClick(index, menuType, menuId, menuTitle) {
                this.checkedIndex = index;
                localStorage.setItem("checkedIndex", index);
                switch (index) {
                    case 1:
                        this.$router.push({ path: "/" });
                        break;
                    case 2:
                        this.$router.push({ path: "/HouseList" });
                        break;
                    case 3:
                        if(menuId == 0){
                            // 准入公示
                            this.$router.push({ path: "/PubilcyInfo"});
                        }
                        else if(menuId == 1){
                            // 轮候公示
                            this.$router.push({ path: "/PubilcyWaitingInfo"});
                        }
                        else if(menuId == 2){
                            // 候租自查
                            this.$router.push({ path: "/PubilcyWaitingNum"});
                        }
                        break;
                    // 新闻资讯
                    case 4: 
                        // 新闻资讯
                        this.$router.push({ path: "/News", query: { name: menuTitle,type:menuType,id:menuId } });
                        break;
                    // 办事指南
                    case 5:
                        this.$router.push({ path: "/Policy", query: { name: menuTitle,type:menuType,id:menuId } });
                        break;
                     //文档下载
                    case 6:
                        this.$router.push({ path: "/Download", query: { name: menuTitle,type:menuType,id:menuId } });
                        break;
                    // 关于我们
                    case 7:
                        this.$router.push({ path: "/ContactUs", query: { name: menuTitle,type:menuType,id:menuId } });
                        break;
                    default:
                        break;
                }
            }
        },
        created() {
            this.checkedIndex = localStorage.getItem("checkedIndex") == null ? 1 : localStorage.getItem("checkedIndex");
        },
        mounted: function () {
            // 获取所有主菜单下的子菜单项
            PortalApi.getSubmoduleList().then(res=>{
                if(res.data){
                    // 0、公示信息
                    var node = res.data.filter(function(ele){return ele.moduleType == 0});
                    if(node != null && node.length){
                        this.publiclyList = node[0].menuList;
                    }

                    // 1、新闻资讯
                    node = res.data.filter(function(ele){return ele.moduleType == 1});
                    if(node != null && node.length){
                        this.newsList = node[0].menuList;
                    }

                    // 2、办事指南
                    node = res.data.filter(function(ele){return ele.moduleType == 2});
                    if(node != null && node.length){
                        this.serviceMenuList = node[0].menuList;
                    }

                    // 3、文档下载
                    node = res.data.filter(function(ele){return ele.moduleType == 3});
                    console.log(node);
                    if(node != null && node.length){
                        this.downloadMenuList = node[0].menuList;
                    }

                    // 4、关于我们
                    node = res.data.filter(function(ele){return ele.moduleType == 4});
                    
                    if(node != null && node.length){
                        this.contactUsMenuList = node[0].menuList;
                    }                    
                }
            })


            // // 获取关于我们中子菜单项
            // PortalApi.getSubmoduleList(0).then(res=>{
            //     this.contactUsMenuList = res.data;
            // });

            // // 获取新闻中子菜单项
            // PortalApi.getSubmoduleList(1).then(res=>{
            //     this.newsList = res.data;
            // });

            // // 获取政策法规中子菜单项
            // PortalApi.getSubmoduleList(2).then(res=>{
            //     this.policyList = res.data;
            // });
            
            // // 获取服务指南中子菜单项
            // PortalApi.getSubmoduleList(3).then(res=>{
            //     if(res.data){
            //         let that = this;
            //         res.data.forEach(function(item){
            //             if(item.id != 37){
            //                 that.serviceMenuList.push(item);
            //             }
            //         })
            //     }
            // });

            // // 文档下载
            // PortalApi.getSubmoduleList(5).then(res=>{
            //     if(res.data){
            //         let that = this;
            //         res.data.forEach(function(item){
            //             that.downloadMenuList.push(item);
            //         })
            //     }
            // })

            this.checkedIndex = localStorage.getItem("checkedIndex") == null ? 1 : localStorage.getItem("checkedIndex");
            getUserInfo().then(data => {
                this.UserInfo = data;
            });
        },
    };
</script>
<style scoped>
    .container {
        width: 100%;
        margin: 0 auto;
    }

    .mini-headPhoto {
        height: 25px;
        width: 25px;
        overflow: hidden;
        border-radius: 50%;
        vertical-align: middle;
    }

    .logo {
        height: 75px;
        width: 1170px;
        margin: 0 auto;
        padding-top: 17px;
    }

    #logo {
        width: 385px;
        height: 54px;
        float: left;
    }

    #logo img {
        height: 100%;
    }

    #login {
        float: left;
        text-align: right;
        padding-top: 27px;
        margin-left: 466px;
        width: 300px;
        font-size: 16px;
        font-weight: 400;
        color: #343434;
        line-height: 22px;
    }

    #login span {
        cursor: pointer;
    }

    .nav {
        height: 54px;
        margin: 0 auto;
        background: #2c7acc;
    }

    #nav {
        height: 100%;
        width: 1170px;
        margin: 0 auto;
        border: none;
        background: #2c7acc;
    }

    #nav > ul {
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px;
        width: 1170px;
        border: none;
        background: #2c7acc;
        text-align: center;
    }

    #nav > ul > li {
        cursor: pointer;
        width: 104px;
        height: 34px;
        padding-top: 18px;
        /* margin-right: -90px; */
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
    }

    #nav > ul > li:last-child {
        margin-right: 0px;
    }

    #nav > ul > li:hover {
        background: #1965b5;
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
    }

    .unit-register {
        border: 1px solid #333333;
        padding: 3px 5px;
    }

    .active {
        background: #1965b5;
    }

    #nav > ul > li > ul {
        background-color: #ffffff;
        color: #7e7e7e;
        width: 104px;
        text-align: center;
        padding-left: 0;
        margin-top: 13px;
    }

    #nav > ul > li > ul > li {
        list-style: none;
        width: 104px;
        height: 34px;
        line-height: 34px;
        font-family: Source Han Sans SC;
        font-weight: 400;
    }

    #nav > ul > li > ul > li:hover {
        background-color: #f4f4f4;
    }

    #nav > ul > li:nth-child(7) >ul#nav-about{
        display: none;
    }

    #nav > ul > li:nth-child(7):hover >ul#nav-about{
        display: block;
    }

     #nav > ul > li:nth-child(6) >ul#nav-download{
        display: none;
    }

    #nav > ul > li:nth-child(6):hover >ul#nav-download{
        display: block;
    }

    #nav > ul > li:nth-child(5) >ul#nav-service{
        display: none;
    }

    #nav > ul > li:nth-child(5):hover >ul#nav-service{
        display: block;
    }

    #nav > ul > li:nth-child(4) >ul#nav-news{
        display: none;
    }

    #nav > ul > li:nth-child(4):hover >ul#nav-news{
        display: block;
    }
    #nav > ul > li:nth-child(3) >ul#nav-publicly{
        display: none;
    }

    #nav > ul > li:nth-child(3):hover >ul#nav-publicly{
        display: block;
    }

    .shadow{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 2px;
        border: none;
    }

</style>
